const StorageContants = {
    ACCESS_TOKEN: 'token',
    USER_DETAIL: 'user',
    ACTIVE_CUSTOMER_NUMBER: 'active_customer_number',
    UNIQUE_DEVICE_ID: 'UNIQUE_DEVICE_ID',
    TURN_OFF_SELFVIEW: 'TURN_OFF_SELFVIEW',
};

export default StorageContants;
